<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [baseZIndex]="10000"
  [header]="getDialogHeader()">
  <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
    <app-row>
      <app-input
        label="First Name"
        i18n-label="@@firstNameLabel"
        placeholder="Enter first name"
        i18n-placeholder="@@firstNamePlaceholder"
        [required]="true"
        formControlName="firstName"
        [touched]="userForm.get('firstName')?.touched"
        [errorMessage]="userForm.get('firstName')?.errors"
      >
      </app-input>

      <app-input
        label="Last Name"
        i18n-label="@@lastNameLabel"
        placeholder="Enter last name"
        i18n-placeholder="@@lastNamePlaceholder"
        [required]="true"
        formControlName="lastName"
        [touched]="userForm.get('lastName')?.touched"
        [errorMessage]="userForm.get('lastName')?.errors"
      >
      </app-input>
    </app-row>

    <app-row>
      <app-input
        label="Phone"
        i18n-label="@@phoneLabel"
        placeholder="Enter phone"
        i18n-placeholder="@@phonePlaceholder"
        [required]="true"
        formControlName="phone"
        [touched]="userForm.get('phone')?.touched"
        [errorMessage]="userForm.get('phone')?.errors"
      >
      </app-input>

      <app-input
        label="Email"
        i18n-label="@@emailLabel"
        placeholder="Enter email"
        i18n-placeholder="@@emailPlaceholder"
        [required]="true"
        formControlName="email"
        [touched]="userForm.get('email')?.touched"
        [errorMessage]="userForm.get('email')?.errors"
      >
      </app-input>
    </app-row>

    <app-row>
      <app-input
        label="Call Sign"
        i18n-label="@@callSignLabel"
        placeholder="Optional call sign"
        i18n-placeholder="@@callSignPlaceholder"
        formControlName="callSign"
        [touched]="userForm.get('callSign')?.touched"
        [errorMessage]="userForm.get('callSign')?.errors"
      >
      </app-input>

      <app-input
        label="Unit"
        i18n-label="@@unitLabel"
        placeholder="Optional unit"
        i18n-placeholder="@@unitPlaceholder"
        formControlName="unit"
        [touched]="userForm.get('unit')?.touched"
        [errorMessage]="userForm.get('unit')?.errors"
      >
      </app-input>
    </app-row>

    <ng-container *ngIf="isNewUser">
      <app-row>
        <app-input-multiselect
          label="Role"
          i18n-label="@@roleLabel"
          placeholder="Select a role"
          i18n-placeholder="@@rolePlaceholder"
          [options]="allRoles"
          optionLabel="label"
          optionValue="value"
          [required]="true"
          formControlName="roles"
          [touched]="userForm.get('role')?.touched"
          [errorMessage]="userForm.get('role')?.errors">
        </app-input-multiselect>
      </app-row>

      <app-row>
        <app-input-select
          label="Region"
          i18n-label="@@regionLabel"
          placeholder="Select a region"
          i18n-placeholder="@@regionPlaceholder"
          [options]="regions"
          optionLabel="name"
          optionValue="id"
          [required]="true"
          formControlName="regionId"
          [touched]="userForm.get('regionId')?.touched"
          [errorMessage]="userForm.get('regionId')?.errors"
          (change)="loadOrganizationsForRegion();"
        >
        </app-input-select>

        <app-input-select
          label="Organization"
          i18n-label="@@organizationLabel"
          placeholder="Select an organization"
          i18n-placeholder="@@organizationPlaceholder"
          [options]="filteredOrganizations"
          optionLabel="name"
          optionValue="id"
          [required]="true"
          formControlName="organizationId"
          [touched]="userForm.get('organizationId')?.touched"
          [errorMessage]="userForm.get('organizationId')?.errors"
        >
        </app-input-select>
      </app-row>

    </ng-container>

    <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
      <button pButton label="Cancel" i18n-label="@@cancelButton" class="p-button-text p-mr-2" type="button" (click)="onCancel()"></button>
      <button pButton label="Save" i18n-label="@@saveButton" class="p-button-primary" type="submit"></button>
    </div>
  </form>
</p-dialog>